import ReActivateInfoCard from './ReActivateInfoCard'

export default ReActivateInfoCard
